import React, { useEffect, useState } from "react";
import { ShieldCheck, FlaskConical } from "lucide-react";

const STORAGE_KEY = "luviarx_age_gate_v1";

export const AgeGateModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Skip on admin utility routes (e.g. Mark-as-Shipped or Refund magic
    // links opened from the New Order Received email on a phone). These
    // aren't product-facing pages so the 21+ modal is unnecessary friction.
    if (
      window.location.pathname.startsWith("/mark-shipped/") ||
      window.location.pathname.startsWith("/refund/")
    ) return;
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) setOpen(true);
  }, []);

  if (!open) return null;

  const handleAgree = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setOpen(false);
  };

  const handleExit = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div
      data-testid="age-gate-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 animate-fade-in"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-charcoal-600/50 backdrop-blur-md" />

      <div className="relative w-full max-w-lg bg-white rounded-[2rem] shadow-hover p-8 md:p-10 text-center overflow-hidden border border-charcoal-100/60 animate-fade-up">
        <div className="absolute -top-12 -right-12 w-44 h-44 rounded-full bg-sage-100 opacity-60" />
        <div className="absolute -bottom-16 -left-10 w-40 h-40 rounded-full bg-cream-300 opacity-60" />

        <div className="relative">
          <div className="mx-auto w-14 h-14 rounded-full bg-sage-100 flex items-center justify-center mb-6">
            <FlaskConical className="w-6 h-6 text-sage-600" strokeWidth={1.6} />
          </div>

          <p className="overline mb-3">Research Acknowledgment</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold leading-tight text-charcoal-600 mb-4">
            21+ Researcher Verification
          </h2>

          <div className="text-charcoal-400 text-sm md:text-[15px] leading-relaxed space-y-3 text-left">
            <p>
              <span className="font-medium text-charcoal-600">You must be 21 years of age or older</span> to enter this website.
            </p>
            <p>
              By entering this site, you confirm that you are a qualified researcher, laboratory professional, or purchasing strictly for lawful research purposes.
            </p>
            <p>
              Products sold on this website are <span className="font-medium text-charcoal-600">for research use only and are not intended for human consumption</span>.
            </p>
            <p>
              These products are <span className="font-medium text-charcoal-600">not FDA approved</span> for diagnostic or therapeutic use.
            </p>
            <p className="text-xs text-charcoal-300 pt-1">
              LuviaRx reserves the right to refuse service at its discretion.
            </p>
          </div>

          <div className="mt-7 flex flex-col-reverse sm:flex-row gap-3 sm:gap-4 sm:justify-center">
            <button
              data-testid="age-gate-exit-button"
              onClick={handleExit}
              className="btn-secondary w-full sm:w-auto"
            >
              Exit
            </button>
            <button
              data-testid="age-gate-agree-button"
              onClick={handleAgree}
              className="btn-primary w-full sm:w-auto"
            >
              <ShieldCheck className="w-4 h-4 mr-2" strokeWidth={2} />
              I Agree / Enter Site
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeGateModal;
